@if (loading()) {
  <div class="email-template-preview-placeholder flex-horizontal flex-center justify-center">
    <oui-loading size="xs"></oui-loading>
  </div>
} @else if (safeHtml()) {
  <div class="email-template-preview-frame-wrapper">
    <iframe
      class="email-template-preview-frame"
      [srcdoc]="safeHtml()"
      sandbox="">
    </iframe>
  </div>
}
